const CREATED_AND_ASSIGNED_MESSAGE =
  'El cliente fue creado y asignado a la orden correctamente.';

interface AssignCreatedCustomerOptions {
  saveCustomer: (options: {
    showSuccess: boolean;
    refreshList: boolean;
  }) => Promise<{ id?: number | null } | null>;
  refreshCustomers: () => Promise<unknown>;
  changeCustomer: (
    customerId: number,
    successMessage: string
  ) => Promise<unknown> | void;
}

export const assignCreatedCustomerToOrder = async ({
  saveCustomer,
  refreshCustomers,
  changeCustomer,
}: AssignCreatedCustomerOptions) => {
  const createdCustomer = await saveCustomer({
    showSuccess: false,
    refreshList: false,
  });

  if (!createdCustomer?.id) return;

  await refreshCustomers();
  return changeCustomer(
    Number(createdCustomer.id),
    CREATED_AND_ASSIGNED_MESSAGE
  );
};
